const getAppsUrl = () => import.meta.env.VITE_LASSO_APPS_URL;
const getInsightsUrl = () => import.meta.env.VITE_LASSO_INSIGHTS_URL;
const getApiUrl = () => import.meta.env.VITE_API_URL;

export default {
  getAppsUrl,
  getInsightsUrl,
  getApiUrl,
};
